import { getLocalizedString } from "@grandvisionhq/utils";
import { getLineItemProduct } from "../../../utils/mappers/view/visual-line-item/utils/get-line-item-product.js";
import { mapAppliedDiscounts } from "../../../utils/mappers/view/visual-line-item/utils/map-applied-discounts.js";
import { mapSubscriptionProperties } from "../../../utils/mappers/view/visual-line-item/utils/map-subscription-properties.js";
import { getAttribute } from "../../../../../../utils/utils/get-line-item-attribute.js";
import { getProductUrl } from "../../../../../../utils/utils/get-line-item-product-url.js";
const mapProductType = (serverType) => {
  switch (serverType.toLowerCase()) {
    case "frames":
      return "frames";
    case "sunglasses":
      return "sunglasses";
    case "solutions":
      return "solutions";
    case "ready-readers":
      return "ready-readers";
    case "accessories":
      return "accessories";
    default:
      return "sunglasses";
  }
};
const toBaseLineItem = (serverLineItem, settings, intl) => {
  const product = getLineItemProduct(serverLineItem);
  const { convertToSubscription, isSubscription, subscriptionDetails } = mapSubscriptionProperties(
    serverLineItem,
    settings.subscriptionIntervalsFallback
  );
  return {
    id: serverLineItem.id,
    productUrl: !settings.isReadOnly ? getProductUrl(
      settings.productLinkFormatter,
      serverLineItem,
      getLocalizedString(product.masterData.current.slug, intl.locale),
      intl.locale
    ) : void 0,
    sku: serverLineItem.sku,
    lineItemId: serverLineItem.id,
    productType: mapProductType(product.productType),
    quantity: `${intl.getLabel("cart.item.quantity")}: ${serverLineItem.quantity}`,
    subtitle: serverLineItem.__typename !== "LineItemBundle" ? `${getAttribute(
      serverLineItem.legacyProduct.masterData.current.variant,
      "brandModelCode"
    )}` : "",
    price: serverLineItem.price.total.gross,
    originalPrice: serverLineItem.price.total.subtotal,
    discountPrice: serverLineItem.price.total.discount.amount || void 0,
    unitPrice: {
      price: serverLineItem.price.unit.gross,
      originalPrice: serverLineItem.price.unit.subtotal,
      discountPrice: serverLineItem.price.unit.discount.amount || void 0,
      ...serverLineItem.price.unit.tax.portions[0] ? {
        tax: serverLineItem.price.unit.tax.portions[0].amount,
        taxRate: serverLineItem.price.unit.tax.portions[0].rate
      } : null,
      appliedDiscounts: mapAppliedDiscounts(
        serverLineItem.price.unit.discount.appliedDiscounts,
        intl
      )
    },
    brand: getAttribute(product.masterData.current.variant, "brand"),
    displayName: getLocalizedString(product.masterData.current.name, intl.locale),
    relativeDiscount: Number((serverLineItem.price.total.discount.percentage * 100).toFixed(2)) || 0,
    isSubscription,
    subscriptionDetails,
    convertToSubscription,
    eligibleInsurance: serverLineItem.eligibleInsurance ? { ...serverLineItem.eligibleInsurance } : void 0,
    insurance: serverLineItem.insurance ? { ...serverLineItem.insurance } : void 0,
    deliveryEstimation: serverLineItem.deliveryEstimation ? { ...serverLineItem.deliveryEstimation } : void 0
  };
};
export {
  toBaseLineItem
};
//# sourceMappingURL=base-line-item.js.map
